import React from 'react';
import { CheckCircle } from 'lucide-react';
import { aboutData, profileData } from '../data/mock';

const About = () => {
  return (
    <section id="about" className="py-20 lg:py-28 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="mb-12">
          <span className="text-sm font-medium text-blue-600 tracking-wide uppercase mb-2 block">
            About
          </span>
          <h2 className="text-3xl lg:text-4xl font-light text-gray-900 tracking-tight">
            A bit about me
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16">
          {/* Bio */}
          <div>
            {aboutData.bio.split('\n\n').map((paragraph, index) => (
              <p
                key={index}
                className="text-gray-600 leading-relaxed mb-5 last:mb-0"
              >
                {paragraph}
              </p>
            ))}
          </div>

          {/* Highlights & Stats */}
          <div>
            <h3 className="text-base font-medium text-gray-900 mb-5">
              What I bring
            </h3>
            <ul className="space-y-3 mb-10">
              {aboutData.highlights.map((highlight, index) => (
                <li
                  key={index}
                  className="flex items-center gap-3"
                >
                  <CheckCircle className="w-4 h-4 text-blue-600 flex-shrink-0" />
                  <span className="text-gray-600 text-sm">{highlight}</span>
                </li>
              ))}
            </ul>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6 pt-8 border-t border-gray-200">
              <div>
                <div className="text-3xl font-light text-gray-900">{profileData.experience}</div>
                <div className="text-sm text-gray-500 mt-1">Experience</div>
              </div>
              <div>
                <div className="text-3xl font-light text-gray-900">Full-Stack</div>
                <div className="text-sm text-gray-500 mt-1">Specialization</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
